export default __webpack_public_path__ + "static/media/pantry2-before1-480w.c4590400.avif";